import React from 'react'; 
import { Link } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom'; 
import { toast } from 'react-toastify'; 
import Button from '../../../shared/components/ui/Button'; 
import GoogleIcon from '../../../shared/components/icons/GoogleIcon'; 
import { loginUser } from '../../../services/api'; 
import { setAuth } from '../utils/authStorage'; 
import { normalizeZambiaPhone } from '../utils/phone'; 
import CardIcon from '../../../shared/components/icons/CardIcon';
 
function LoginPage() { 
  const navigate = useNavigate(); 
  const [showPassword, setShowPassword] = React.useState(false); 
  const [form, setForm] = React.useState({ 
    identifier: '', 
    password: '', 
  }); 
 
  const onChange = (key) => (e) => { 
    setForm((prev) => ({ ...prev, [key]: e.target.value })); 
  }; 
 
  const onSubmit = async (e) => { 
    e.preventDefault(); 
 
    if (!form.identifier || !form.password) { 
      toast.error('Please enter phone/email and password.'); 
      return; 
    } 
 
    try { 
      const data = await loginUser({ 
        identifier: normalizeZambiaPhone(form.identifier), 
        password: form.password, 
      }); 
 
      setAuth({ token: data.token, user: data.user }); 
      toast.success(data.message || 'Login successful'); 
 
      const role = data?.user?.role; 
      if (role === 'CLIENT') navigate('/client', { replace: true }); 
      else if (role === 'ADMIN') navigate('/admin', { replace: true }); 
      else navigate('/worker', { replace: true }); 
    } catch (error) { 
      toast.error(error?.message || 'Login failed'); 
    } 
  }; 
 
  return ( 
    <div className="mx-auto w-full max-w-md"> 
      <div className="rounded-3xl border border-slate-200 bg-white/90 p-6 shadow-xl shadow-slate-200/40 backdrop-blur-sm sm:p-8"> 
        <div className="mb-5 flex justify-center">
          <img src="/logo.png" alt="Tuma Jobs" className="h-20 w-20 object-contain" />
        </div>
        <h1 className="text-center text-2xl font-bold tracking-tight text-navy">Log in</h1>
        <p className="mt-2 text-center text-sm text-slate-600">Log in to continue with Tuma Jobs.</p>
 
        <div className="mt-6"> 
          <form onSubmit={onSubmit} className="space-y-4"> 
            <div> 
              <label className="mb-2 block text-sm font-medium text-slate-700">Phone number or email</label>
              <input 
                value={form.identifier} 
                onChange={onChange('identifier')} 
                autoComplete="username" 
                placeholder="Enter your phone or email" 
                className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100" 
              /> 
            </div> 
 
            <div className="relative"> 
              <label className="mb-2 block text-sm font-medium text-slate-700">Password</label> 
              <input 
                value={form.password} 
                onChange={onChange('password')} 
                type={showPassword ? 'text' : 'password'} 
                autoComplete="current-password" 
                placeholder="Enter your password" 
                className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 pr-12 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100" 
              /> 
              <button type="button" onClick={() => setShowPassword((current) => !current)} aria-label={showPassword ? 'Hide password' : 'Show password'} title={showPassword ? 'Hide password' : 'Show password'} className="absolute bottom-3 right-3 rounded-md p-1 text-slate-500 hover:text-navy focus:outline-none focus:ring-2 focus:ring-orange-400">
                <CardIcon name="eye" className="h-5 w-5" />
              </button>
            </div> 

            <div className="text-right">
              <Link to="/forgot-password" className="text-sm font-semibold text-navy hover:underline">Forgot password?</Link>
            </div>
 
            <Button type="submit" variant="primary" className="w-full"> 
              Log in
            </Button> 
          </form> 
 
          <div className="my-5 flex items-center gap-3"> 
            <div className="h-px flex-1 bg-slate-200" /> 
            <span className="text-xs font-semibold text-slate-500">or</span> 
            <div className="h-px flex-1 bg-slate-200" /> 
          </div> 
 
          <button 
            type="button" 
            onClick={() => toast.info('Google login will be added later.')} 
            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2" 
          > 
            <GoogleIcon className="h-5 w-5" /> 
            Continue with Google 
          </button> 
 
          <p className="mt-6 text-center text-sm text-slate-600"> 
            Don&apos;t have an account?{' '} 
            <Link to="/signup" className="font-semibold text-navy hover:underline"> 
              Sign up 
            </Link> 
          </p> 
          <p className="mt-4 text-center text-xs font-medium text-slate-500">Find work. Hire workers. Get things done.</p>
        </div> 
      </div> 
    </div> 
  ); 
} 
 
export default LoginPage; 

/*this same code ofs without changing anything just change the position of forgot password "import React from 'react'; 
import { Link } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom'; 
import { toast } from 'react-toastify'; 
import Button from '../../../shared/components/ui/Button'; 
import GoogleIcon from '../../../shared/components/icons/GoogleIcon'; 
import { loginUser } from '../../../services/api'; 
import { setAuth } from '../utils/authStorage'; 
import { normalizeZambiaPhone } from '../utils/phone'; 
 
function LoginPage() { 
  const navigate = useNavigate(); 
  const [showPassword, setShowPassword] = React.useState(false); 
  const [form, setForm] = React.useState({ 
    identifier: '', 
    password: '', 
  }); 
 
  const onChange = (key) => (e) => { 
    setForm((prev) => ({ ...prev, [key]: e.target.value })); 
  }; 
 
  const onSubmit = async (e) => { 
    e.preventDefault(); 
 
    if (!form.identifier || !form.password) { 
      toast.error('Please enter phone/email and password.'); 
      return; 
    } 
 
    try { 
      const data = await loginUser({ 
        identifier: normalizeZambiaPhone(form.identifier), 
        password: form.password, 
      }); 
 
      setAuth({ token: data.token, user: data.user }); 
      toast.success(data.message || 'Login successful'); 
 
      const role = data?.user?.role; 
      if (role === 'CLIENT') navigate('/client', { replace: true }); 
      else if (role === 'ADMIN') navigate('/admin', { replace: true }); 
      else navigate('/worker', { replace: true }); 
    } catch (error) { 
      toast.error(error?.message || 'Login failed'); 
    } 
  }; 
 
  return ( 
    <div className="mx-auto w-full max-w-md"> 
      <div className="rounded-3xl border border-slate-200 bg-white/90 p-6 shadow-xl shadow-slate-200/40 backdrop-blur-sm sm:p-8"> 
        <h1 className="text-2xl font-bold tracking-tight text-navy">Login</h1> 
        <p className="mt-2 text-sm text-slate-600"> 
          Sign in to manage your applications and saved jobs. 
        </p> 
 
        <div className="mt-6"> 
          <form onSubmit={onSubmit} className="space-y-4"> 
            <div> 
              <label className="mb-2 block text-sm font-medium text-slate-700">Phone or email</label> 
              <input 
                value={form.identifier} 
                onChange={onChange('identifier')} 
                autoComplete="username" 
                placeholder="+260971234567" 
                className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100" 
              /> 
            </div> 
 
            <div className="text-right"><Link to="/forgot-password" className="text-sm font-semibold text-navy hover:underline">Forgot password?</Link></div> 
 
            <div> 
              <label className="mb-2 block text-sm font-medium text-slate-700">Password</label> 
              <input 
                value={form.password} 
                onChange={onChange('password')} 
                type={showPassword ? 'text' : 'password'} 
                autoComplete="current-password" 
                placeholder="••••••••" 
                className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 pr-16 text-sm text-slate-900 outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100" 
              /> 
              <button type="button" onClick={() => setShowPassword((current) => !current)} className="relative float-right -mt-9 mr-4 text-xs font-semibold text-slate-600">{showPassword ? 'Hide' : 'Show'}</button> 
            </div> 
 
            <Button type="submit" variant="primary" className="w-full"> 
              Login 
            </Button> 
          </form> 
 
          <div className="my-5 flex items-center gap-3"> 
            <div className="h-px flex-1 bg-slate-200" /> 
            <span className="text-xs font-semibold text-slate-500">or</span> 
            <div className="h-px flex-1 bg-slate-200" /> 
          </div> 
 
          <button 
            type="button" 
            onClick={() => toast.info('Google login will be added later.')} 
            className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2" 
          > 
            <GoogleIcon className="h-5 w-5" /> 
            Continue with Google 
          </button> 
 
          <p className="mt-6 text-center text-sm text-slate-600"> 
            Don&apos;t have an account?{' '} 
            <Link to="/signup" className="font-semibold text-navy hover:underline"> 
              Sign up 
            </Link> 
          </p> 
        </div> 
      </div> 
    </div> 
  ); 
} 
 
export default LoginPage; 
 
"*/